<template>
  <Modal v-if="showModal" @close="closeModalAddComment">
    <Loading v-if="loading" />
    <div class="addAlarmComment">
      <div class="addAlarmComment__header">
        <span class="title">{{ $t('addAlarmComment') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="closeModalAddComment"
        />
      </div>
      <div class="addAlarmComment__body">
        <InfoAboutAlarm :activeAlarm="activeAlarm" />
        <div class="addAlarmComment__body-description">
          <FormKit
            type="form"
            id="alarmComment-form"
            v-model="formData"
            :actions="false"
            @submit="$emit('saveAlarmComment', formData.alarmInfo)"
          >
            <label class="label-description" for="description">
              {{ $t('comment') }}
            </label>
            <textarea
              v-model="formData.alarmInfo"
              id="description"
              class="input-description"
              maxlength="250"
            >
            </textarea>
          </FormKit>
        </div>
      </div>
      <div class="addAlarmComment__buttons">
        <Button variant="filled" :title="$t('save')" @click="submitHandler" />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="closeModalAddComment"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import InfoAboutAlarm from './InfoAboutAlarm/InfoAboutAlarm.vue';
import Loading from '@/views/Loading.vue';

@Options({
  name: 'AddAlarmComment',
  props: ['showModal', 'activeAlarm'],
  components: {
    InfoAboutAlarm,
    Loading
  },
  data() {
    return {
      loading: false,
      formData: {
        alarmInfo: ''
      }
    };
  },
  methods: {
    submitHandler() {
      this.$formkit.submit('alarmComment-form');
    },
    closeModalAddComment() {
      this.formData.alarmInfo = '';
      this.$emit('closeModal');
    }
  }
})
export default class AddAlarmComment extends Vue {}
</script>

<style lang="scss">
.addAlarmComment {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .addAlarmComment__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .addAlarmComment__body {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    .addAlarmComment__body-description {
      position: relative;
      width: 353px;
      height: 278px;
      margin-left: 16px;
      label {
        position: absolute;
        font-family: 'Ubuntu-Regular';
        top: -6px;
        left: 15px;
        padding: 0 5px;
        background: $white;
        color: $label;
        font-weight: 400;
        font-size: $twelveSize;
        line-height: $fourteenSize;
        z-index: 1;
      }
      textarea {
        width: 319px;
        height: 246px;
        padding: 16px;
        font-size: $fourteenSize;
        border: 1px solid $border;
        border-radius: 8px;
        resize: none;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
